<template>
  <v-dialog
      v-model="open"
      class="dialog"
      max-width="900"
      overlay-opacity="0.8"
  >

    <v-btn class="close-button" color="gray" fab x-small
           @click="open=false">
      <v-icon>mdi-close</v-icon>
    </v-btn>
    <v-card class="pa-2 panel">
      <v-container>
        <v-row>
          <v-col>
            <span class="title">โปรโมชั่น: {{ object.name }}</span>


            <v-simple-table v-if="object.promotion_type==='S'" class="itemTable" fixed-header>
              <template v-slot:default>
                <thead>
                <tr class="ItemHead">
                  <th class="text-left" colspan="2">รายการ</th>
                  <th class="text-right d-none d-md-table-cell">ปกติ</th>
                  <th class="text-right d-none d-md-table-cell">โปรฯ</th>
                  <th class="text-center" colspan="2">จำนวน</th>
                  <th class="text-right d-none d-md-table-cell">รวม</th>
                </tr>
                </thead>
                <tbody class="cart-item">
                <tr v-for="(item, index) in object.product_promotions"
                    :key="index"
                    :currentIndex="index"
                    :item="item"
                    class="ItemRow"
                >
                  <td style="padding: 0;width: 64px">
                    <v-img
                        v-if="item.product.image_path"
                        :src="'/'+item.product.image_path+'.64.jpg'"
                        aspect-ratio="1"
                        class="grey lighten-2"
                    ></v-img>
                    <v-img
                        v-else
                        :src="'/images/products/default.64.jpg'"
                        aspect-ratio="1"
                        class="grey lighten-2"
                    ></v-img>
                  </td>
                  <td style="font-size: 18px" @click="onClickProduct(index)"> {{ item.index_no }}.) {{
                      (item.product ? item.product.nickname : null) ||
                      item.product_code
                    }}
                  </td>
                  <!--<td @click="onClickProduct(index)" class="text-right">{{ number_format(item.price_init)}}</td>-->
                  <td class="text-right d-none d-md-table-cell" style="text-decoration: line-through">
                    {{ $helper.number_format(item.init_price, 2, 2) }}
                  </td>
                  <td class="text-right d-none d-md-table-cell" style="font-size: 24px">
                    {{ $helper.number_format(item.display_price, 2, 2) }}
                  </td>

                  <td class="text-right d-none d-md-table-cell pl-6" style="font-size: 24px">
                    {{ $helper.number_format(item.quantity) }}
                  </td>
                  <td class="text-left d-none d-md-table-cell" style="font-size: 24px">
                      <span
                          style="font-size: 0.7em;font-weight:normal;">{{
                          item.product ? $helper.parseUnit(item.product.unit_primitive) : ''
                        }}</span>
                  </td>
                  <td class="text-right  d-none d-md-table-cell" style="font-size: 18px" @click="onClickProduct(index)">
                    {{
                      $helper.number_format(item.display_price * item.quantity, 2, 2)
                    }}
                  </td>

                </tr>

                </tbody>
              </template>
            </v-simple-table>

            <v-simple-table v-if="['D','T'].includes(object.promotion_type)" class="itemTable" fixed-header>
              <template v-slot:default>
                <thead>
                <tr class="ItemHead">
                  <th class="text-left" colspan="2">ซื้อสินค้า</th>
                  <th class="text-right d-none d-md-table-cell">ราคา</th>
                  <th class="text-right d-none d-md-table-cell"></th>
                </tr>
                </thead>
                <tbody class="cart-item">
                <tr v-for="(item, index) in object.product_promotions.filter(i=>i.promotion_type==='D')"
                    :key="index"
                    :currentIndex="index"
                    :item="item"
                    class="ItemRow"
                >
                  <td style="padding: 0;width: 64px">
                    <v-img
                        v-if="item.product.image_path"
                        :src="'/'+item.product.image_path+'.64.jpg'"
                        aspect-ratio="1"
                        class="grey lighten-2"
                    ></v-img>
                    <v-img
                        v-else
                        :src="'/images/products/default.64.jpg'"
                        aspect-ratio="1"
                        class="grey lighten-2"
                    ></v-img>
                  </td>
                  <td style="font-size: 18px" @click="onClickProduct(index)"> {{ item.index_no }}.) {{
                      (item.product ? item.product.nickname : null) ||
                      item.product_code
                    }}
                  </td>
                  <!--<td @click="onClickProduct(index)" class="text-right">{{ number_format(item.price_init)}}</td>-->
                  <td class="text-right d-none d-md-table-cell" style="font-size: 24px">
                    {{ $helper.number_format(item.display_price, 2, 2) }}
                  </td>
                  <td style="text-align: right">
                    <v-btn :class="$store.state.carts.current_item_map[item.product.id]?'primary':''"
                           :disabled="product && item.product && item.product.non_over_stock && product.stock_MT * item.product.unit_prim_rate-item.product.reserve_MT<=0"
                           class="add-button"
                           @click.stop="onClickAddCart(item.product)">เพิ่ม
                      <span v-if="$store.state.carts.current_item_map[item.product.id]">
              {{ $store.state.carts.current_item_map[item.product.id].quantity }}</span>
                    </v-btn>
                  </td>
                </tr>

                </tbody>
              </template>
            </v-simple-table>


          </v-col>
        </v-row>

        <v-row v-if="object.promotion_type==='T'">
          <v-col>
            <div v-for="item in object.product_promotions.filter(i=>i.promotion_type==='D').slice(0,1)"
                 style="text-align: right">

                    <span style="font-size: 2em">
                      จำนวนตั้งแต่
                      {{ $helper.number_format(item.quantity) }} <span
                        style="font-size: 0.7em;font-weight:normal;">{{
                        item.product ? $helper.parseUnit(item.product.unit_primitive) : ''
                      }}</span>
                      ขึ้นไป
                  รับส่วนลด
                       <span class="stock-md">
                      {{ $helper.number_format(object.discount_percent) }} <span
                           class="percent">%</span>
                    </span>
                    </span>
            </div>
          </v-col>
        </v-row>

        <v-row v-if="object.promotion_type==='D'">
          <v-col>
            <div v-for="item in object.product_promotions.filter(i=>i.promotion_type==='D').slice(0,1)"
                 style="text-align: right">

                    <span style="font-size: 2em">
                      ครบจำนวน
                      {{ $helper.number_format(item.quantity) }} <span
                        style="font-size: 0.7em;font-weight:normal;">{{
                        item.product ? $helper.parseUnit(item.product.unit_primitive) : ''
                      }}</span>
                      เลือกรับ
                    </span>
            </div>
          </v-col>
        </v-row>
        <v-row v-if="object.promotion_type==='D'">
          <v-col>
            <span
                v-if="object.product_promotions.filter(i=>i.promotion_type==='F').length>0"
                class="red pl-1" style="color: white">
              เลือกของแถมที่หน้าตะกร้าสินค้า</span>
            <v-simple-table class="itemTable" fixed-header>
              <template v-slot:default>
                <tbody class="cart-item">
                <tr v-for="(item, index) in object.product_promotions.filter(i=>i.promotion_type==='F')"
                    :key="index"
                    :currentIndex="index"
                    :item="item"
                    class="ItemRow "
                    :class="{'free-item-border-parent':!item.is_child,'free-item-border-child':item.is_child}"
                >
                  <td style="padding: 0;width: 64px">
                    <div v-if="item.is_child" style="width:24px;min-height:32px;float: left;display: flex;justify-content: center;align-items: center;">
                      └
                    </div>
                    <v-img
                        v-if="item.product.image_path"
                        :src="'/'+item.product.image_path+'.64.jpg'"
                        aspect-ratio="1"
                        class="grey lighten-2"
                    ></v-img>
                    <v-img
                        v-else
                        :src="'/images/products/default.64.jpg'"
                        aspect-ratio="1"
                        class="grey lighten-2"
                    ></v-img>
                  </td>
                  <td style="font-size: 18px" @click="onClickProduct(index)">  {{
                      (item.product ? item.product.nickname : null) ||
                      item.product_code
                    }}
                  </td>
                  <!--<td @click="onClickProduct(index)" class="text-right">{{ number_format(item.price_init)}}</td>-->
                  <td class="text-right d-none d-md-table-cell" style="font-size: 24px">
                    {{ !item.is_child? (item.display_price>0? $helper.number_format(item.display_price, 2, 2):'ฟรี'):"" }}
                  </td>
                </tr>

                </tbody>
              </template>
            </v-simple-table>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <div v-if="object && object.amount_limit===0"
                 class="title">ไม่จำกัดจำนวน
            </div>
            <div v-if="object && object.amount_limit>0"
                 class="title">จำกัด {{ $helper.number_format(object.amount_limit) }} ชุด
            </div>
            <div v-else
                 class="title">
            </div>
          </v-col>
          <v-col>
            <div v-if="Promotion.calStock(object)!=='n/a'"
                 class="title">เหลือ {{ $helper.number_format(Promotion.calStock(object)) }} ชุด
            </div>

          </v-col>
          <v-col v-if="object.promotion_type==='S'" class=" text-right" cols="5">
            <div v-if="object.product_promotions && object.product_promotions.length>0"
                 class="title">รวม
              <span style="font-size: 2em">{{ $helper.number_format(object.total_price, 2, 2) }} บาท</span>
            </div>
          </v-col>
          <v-col class="col-1">
            <v-btn :loading="loading" class="cart-button float-right" color="primary" fab tile @click="openCart">
              <v-icon>mdi-cart</v-icon>
            </v-btn>
          </v-col>
          <v-col class="col-1">
            <v-btn :loading="loading" class="close-button float-right" color="primary" fab tile @click="open=false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-container>

    </v-card>
  </v-dialog>
</template>
<style lang="scss" scoped>

.view {
  position: relative;
  /*background: #FF0000;*/
}

.panel {
  margin-top: 16px;
}

.close-button {
  float: right;
  margin-top: 0;
  position: absolute;
  right: 24px;
}

.nav {
  z-index: 1;
}

.container {
  position: relative;
  margin-top: 0;
}

.pad-filter {
  padding: 16px 0 0 24px;
}

.search .v-input__control {
  /*height: 60px;*/
}

.theme--light .list-header-row {
  background: #FFFFFF;
}

.theme--dark .list-header-row {
  background: #000000;
}

.delta-button {
  min-width: 32px !important;
  width: 32px !important;
  height: 32px !important;
  margin: 0 4px 0;
}

.delta-text {
  height: 32px !important;
  font-weight: bold;
  font-size: 16px;
  line-height: 1;
  padding: 0 !important;
  width: 82px;
}

.price-text {
  width: 96px;
  text-align: right;
}

.ItemHead {
  th {
    /*font-size: 16px ;*/
  }
}

.ItemRow {
  td {
    /*font-size: 16px ;*/
  }
}


.stock-sm {
  display: none;
}

@media (max-height: 700px) {
  .data-qty {

  }
  .stock-sm {
    display: block;
    position: absolute;
    top: -5px;
    left: -8px;
    font-weight: normal;
    font-size: 10px;
  }

  .stock-md {
    /*padding-top: 2px;*/
  }
}

.add-product {
  width: 200px;
}

.cart-item {
  td {
    padding: 0 4px;
  }

  td.item-qty {
    min-width: 170px;
  }

  td:first-child {
    padding-left: 16px;
  }

  td:last-child {
    padding-right: 16px;
  }
}

.free-item-border-parent{
  border: none !important;;
  td{
    border-bottom: none !important;
    border-top: thin solid rgba(0, 0, 0, 0.12) !important;
  }
}
.free-item-border-child{
  border: none !important;;
  td{
    border: none !important;
  }
}

</style>

<script lang="ts">

import {Product} from '@/models/Product'
import {DataPromotion, Promotion} from '@/models/Promotion'
import router from '@/router'
import Helper from '@/services/Helper.js'

import {Component, Vue} from 'vue-property-decorator'


@Component({
  components: {},
})
export default class PromotionDialog extends Vue {

  search = ''
  open: boolean = false
  loading: boolean = false

  Promotion = Promotion
  object: Promotion = new Promotion()

  price_group = 1

  onApply: Function = () => {
  }

  created() {
    this.$root.$on('openPromotion', this.onOpen)
  }

  onOpen({id, object, onApply}) {
    if (this.open) return
    console.log('Emited', {id, object})
    this.object = new Promotion()
    if (object) {
      this.object = object
    } else if (id) {
      this.object.id = id
      this.getObject()
    }

    this.open = true

    this.onApply = onApply
  }

  async getObject() {
    const id = this.object.id
    this.loading = true
    await Helper.get(Helper.setting.promotion.getResourceAPI.replace('{id}', id))
        .then<{ data: DataPromotion }>(({data}) => {
          console.log('getObject', data.data)
          this.object = data.data
        })
    this.loading = false
  }

  onClickAddCart(product: Product|null, delta = 1) {
    if (this.$store.state.carts.current.id) {
      this.$store.dispatch('alter_item_to_cart', {product, delta})
    } else {
      this.$root.$emit('onWarning', {message: 'กรุณาเลือกลูกค้าก่อนสั่งสินค้า'})
      router.push('/customer')
    }
  }
  onClickProduct(index:number|null){

  }

  openCart(){
    this.open=false
    router.push('/cart')
  }
};

</script>
